import { render, staticRenderFns } from "./ArtistRow.vue?vue&type=template&id=5b1a42a0&scoped=true&"
import script from "./ArtistRow.vue?vue&type=script&lang=js&"
export * from "./ArtistRow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/listrows.css?vue&type=style&index=0&id=5b1a42a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a42a0",
  null
  
)

export default component.exports